import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';

import { debounceTime, Subscription } from 'rxjs';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';

@Component({
    selector: 'app-search-input-field',
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
    ],
    templateUrl: './search-input-field.component.html',
    styleUrl: './search-input-field.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputFieldComponent implements OnInit, OnDestroy {
  @Input() disabled: boolean = false;
  @Input({ required: true }) public placeholder: string;
  @Input() public showSortDirection = true;

  @Output() public searchChanged: EventEmitter<{
    searchInput: string;
    sortDir: string;
  }> = new EventEmitter();

  public form: FormGroup = new FormGroup({
    searchInput: new FormControl(''),
    sortDir: new FormControl('asc'),
  });

  #subs: Subscription;

  public sortOptions: { text: string; value: string }[] = [
    {
      text: 'A-Z',
      value: 'asc',
    },
    {
      text: 'Z-A',
      value: 'desc',
    },
  ];
  eSvgIcons = ESvgIcons;

  public ngOnInit(): void {
    this.#subs = this.form.valueChanges
      .pipe(debounceTime(400))
      .subscribe((formValue) => this.searchChanged.emit(formValue));
  }

  public get generateLabel(): string {
    return this.sortOptions.find((i) => i.value === this.form.value.sortDir)
      ?.text;
  }

  public ngOnDestroy(): void {
    this.#subs.unsubscribe();
  }
}
